import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'componentsV2/Button';
import { Link } from 'react-router';
import { urlIsExternal } from 'helpers/ContentHelper';
import { Braze } from '@foxcorp/cpe-commerce-web';
import Style from './BrazeContent.module.scss';

const BrazeContent = ({
  braze,
  description,
  id,
  imageUrl,
  latestCard,
  link,
  linkText,
  title,
  type,
}) => {
  const contentClass = classNames([Style.brazeContent, Style[type]]);
  useEffect(() => {
    if (latestCard) {
      braze.logContentCardImpressions(new Array(latestCard));
    }
  }, [braze, latestCard]);

  const handleClick = () => {
    Braze.bannerClickAction(latestCard);
    braze.logContentCardClick(latestCard);
  };

  if (type === 'captionedImage') {
    return (
      <div id={id} className={contentClass}>
        <img alt={title} src={imageUrl} />
        <div className={Style.captionedContent}>
          <h2>{title}</h2>
          <p>{description}</p>
          {link && (
            <Button
              primary
              label={linkText}
              url={link}
              onClick={handleClick}
              style={Style.captionedButton}
            />
          )}
        </div>
      </div>
    );
  }

  if (type === 'banner') {
    const isExternal = urlIsExternal(link);
    if (isExternal) {
      return (
        <div id={id} className={contentClass} onClick={handleClick}>
          <a href={link} target="_blank" rel="noopener noreferrer">
            <img alt={title} src={imageUrl} />
          </a>
        </div>
      );
    }
    return (
      <Link to={link} onClick={handleClick}>
        <div id={id} className={contentClass}>
          <img alt={title} src={imageUrl} />
        </div>
      </Link>
    );
  }
  return null;
};

BrazeContent.propTypes = {
  braze: PropTypes.shape({}),
  description: PropTypes.string,
  id: PropTypes.string,
  imageUrl: PropTypes.string,
  latestCard: PropTypes.shape({}),
  link: PropTypes.string,
  linkText: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
};

export default React.memo(BrazeContent);
